
import { arrayOf, nullable, oneOf, oneOfType, shape, string } from 'vue-types';
import { entryShape } from '@/constants/PropTypes';
import query from '@/gql/queries/sections/clientCases.gql';
import {
  COLOR_SCHEME_LIGHT,
  COLOR_SCHEME_DARK,
  SIZE_MEDIUM,
} from '~/constants/General';

const FETCH_LIMIT = 5;

export default {
  inheritAttrs: false,
  props: {
    heading: oneOfType([string(), nullable()]),
    body: oneOfType([string(), nullable()]),
    filter: arrayOf(shape(entryShape).loose),
    colorScheme: oneOf([COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT]).def(
      COLOR_SCHEME_LIGHT
    ),
  },
  data() {
    return {
      SIZE_MEDIUM,
      COLOR_SCHEME_DARK,
      entries: null,
      totalCount: 0,
      fetching: false,
    };
  },
  async fetch() {
    const result = await this.$cms.query({
      query,
      variables: this.queryVariables,
    });
    this.totalCount = result?.totalCount || 0;
    this.entries = result?.entries || [];
  },
  computed: {
    queryVariables() {
      return {
        site: this.$i18n.locale,
        industry: this.$first(this.filter)
          ? parseInt(this.$first(this.filter).id, 10)
          : null,
        limit: FETCH_LIMIT,
      };
    },
    canLoadMore() {
      const entriesLength = this.entries?.length || 0;
      return entriesLength < this.totalCount;
    },
  },
  methods: {
    async loadMore() {
      this.fetching = true;

      try {
        const result = await this.$cms.query({
          query,
          variables: {
            ...this.queryVariables,
            offset: this.entries.length,
          },
        });

        this.totalCount = result?.totalCount || 0;

        const entries = result?.entries || [];
        this.entries = [...this.entries, ...entries];
      } catch (error) {
        this.totalCount = 0;
      }

      this.fetching = false;
    },
  },
};
